module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1242.f3a0980f.png";